import React from 'react'
import { Route } from 'react-router-dom';
import { Switch } from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './Components/HeaderSection/Header';
import Home from './Views/MainHomePage/Home';
import './App.css';
import Create from './Views/MainHomePage/Profile/CreateNft/Create';
import Singlenft from './Views/MainHomePage/Profile/CreateNft/Singlenft'; 
import Footer from './Components/FooterSection/Footer';
import Buydetails from './Views/Buydetail/Buydetails';
import Buyright from './Views/Buydetail/Buyright';
import Buyleft from './Views/Buydetail/Buyleft';
import Contactus from './Views/Conatct/Contactus';
import Trendingcollections from './Views/MainHomePage/Trendingcollections';
import Trendingtableft from './Views/MainHomePage/Trendingtabhomepage/Trendingtableft';
import Createcollection from './Views/Createcollection/Createcollection';
import Editprofile from './Views/Editprofilepage/Editprofile';
import Rankingdetails from './Views/Ranking/Rankingdetails';
import Explore from './Views/Explorepage/Explore';
import Membershipplan from './Views/Membershippage/Membershipplan';
import Mymembership from './Views/Membershippage/Mymembership';
import Collectiondetails from './Views/Createcollection/Collectiondetails';
import Categoriesdetails from './Views/MainHomePage/Categoriespage/Categoriesdetails';
import Tokentable from './Views/MainHomePage/Tokentable.js/Tokentable';
import MembershipNFT from './Views/Membershippage/MembershipNFT';
import Resell from './Views/Resellpage/Resell'; 
import Myitems from './Views/MainHomePage/Profile/Myitems';
import Profile from './Views/MainHomePage/Profilepage/Profile'; 
import AddToken from './Views/Membershippage/AddToken';
import Membershipnfts from './Views/Membershipnftpage/Membershipnfts';
import New_details from './Views/Latestnews/New_details';
import Notarize from './Views/MainHomePage/Notarizepage/Notarize';

const App = () => {
  return (
    // <Router >
      <Router basename='/enefti/'> 
      <Header />
      <Switch>
        <Route exact path='/' > <Home /> </Route>
        <Route exact path='/Createcollection' > <Createcollection /> </Route>
        <Route exact path='Trendingcollections' > <Trendingcollections /> </Route>
        <Route exact path='/Collectiondetails/:collection'> <Collectiondetails /> </Route> 
        <Route exact path='/Categoriesdetails/:category'> <Categoriesdetails /> </Route>
        <Route exact path='/Membershipplan'> <Membershipplan /> </Route>
        <Route exact path='/Mymembership'> <Mymembership /> </Route>
        <Route exact path='/Addtoken'> <AddToken/> </Route>
        <Route exact path='/MembershipNFT'> <MembershipNFT /> </Route>
        <Route exact path='/Create' > <Create /> </Route> 
        <Route exact path='/Trendingtableft'> <Trendingtableft /> </Route>
        <Route exact path='/Myitem' > <Myitems/> </Route>
        <Route exact path='/single-nft'><Singlenft /></Route> 
        <Route exact path='/Notarize'><Notarize /></Route> 
        <Route exact path='/Buyright'><Buyright /></Route>
        <Route exact path='/Buyleft'><Buyleft /></Route>
        <Route exact path='/Buydetails/:id'><Buydetails /></Route>
        <Route exact path='/Contactus'><Contactus /></Route>
        <Route exact path='/Editprofile'> <Editprofile /> </Route>
        <Route exact path='/Rankingdetails' > <Rankingdetails /> </Route>
        <Route exact path='/Explore'> <Explore /> </Route>
        <Route exact path='/Tokentable'> <Tokentable /> </Route>
        <Route exact path='/Resell/:id'> <Resell /> </Route>
        <Route exact path='/Profile/:account'> <Profile /> </Route> 
        <Route exact path='/Membershipnfts'> <Membershipnfts /> </Route>
        <Route exact path='/New_details/:id'> <New_details /> </Route>
      </Switch>
       <Footer />
    </Router>
  )
}

export default App;